import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row, Card, CardBody } from 'reactstrap';

import { Input, Resource } from '@/components/form';
import ResourceForm from '@/components/resources/form';
import View from '@/components/view';

const ZoneTypeForm = ({ match }) => (
  <View>
    <ResourceForm resource="ZoneType" id={match.params.id}>
      {({ submitting, renderActions }) => (
        <>
          <Card>
            <CardBody className={submitting ? 'loading' : ''}>
              <Row>
                <Col lg={6}>
                  <Input name="name" />
                </Col>
                <Col lg={6}>
                  <Resource name="parent" display="name" clearable />
                </Col>
              </Row>
            </CardBody>
          </Card>
          <div className="mt-4 mb-4">{renderActions()}</div>
        </>
      )}
    </ResourceForm>
  </View>
);

ZoneTypeForm.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({ id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) })
  }).isRequired
};

export default ZoneTypeForm;
